module.exports = __webpack_public_path__ + "static/media/audio-rockford-fosgate.bd8f15c6.jpg";